import React from 'react';
import { FaPalette, FaPen, FaVideo, FaCode, FaBlog, FaLightbulb, FaDesktop, FaMobileAlt, FaSearch, FaChartLine } from 'react-icons/fa';
import './PageCss/Services.css';

const Services = () => {
  const serviceCategories = [

    {
      title: "Design Services",
      description: "Creative visual solutions for your brand",
      services: [
        {
          icon: <FaPalette />,
          title: "Graphics Design",
          description: "Logos, branding, and marketing materials"
        },
        {
          icon: <FaDesktop />,
          title: "UI/UX Design",
          description: "User-friendly interface designs"
        },
        {
          icon: <FaMobileAlt />,
          title: "Social Media Design",
          description: "Engaging social media graphics"
        }
      ]
    },
    {
      title: "Video Production",
      description: "Professional video content creation",
      services: [
        {
          icon: <FaVideo />,
          title: "Video Creation",
          description: "High-quality promotional videos"
        },
        {
          icon: <FaLightbulb />,
          title: "Tutorial Videos",
          description: "Educational and training content"
        },
        {
          icon: <FaChartLine />,
          title: "Social Media Videos",
          description: "Platform-optimized video content"
        }
      ]
    },
    {
      title: "Web Development",
      description: "Custom web solutions for your business",
      services: [
        {
          icon: <FaCode />,
          title: "Website Design",
          description: "Custom responsive websites"
        },
        {
          icon: <FaDesktop />,
          title: "Web Applications",
          description: "Interactive web applications"
        },
        {
          icon: <FaMobileAlt />,
          title: "Mobile-First Design",
          description: "Mobile-optimized experiences"
        }
      ]
    }
  ];

  return (
    <div id="services" className="services-section">
      <div className="services-container">
        <div className="services-header" data-aos="fade-up">
          <h2>Our Services</h2>
          <p className="services-subtitle">
            Comprehensive digital solutions for your business growth
          </p>
        </div>

        <div className="services-grid">
          {serviceCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="service-category" data-aos="fade-up">
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
              
              <div className="service-items">
                {category.services.map((service, serviceIndex) => (
                  <div 
                    key={serviceIndex} 
                    className="service-card"
                    data-aos="zoom-in"
                    data-aos-delay={serviceIndex * 100}
                  >
                    <div className="service-icon">{service.icon}</div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services; 